export const BackIcon = ({ color = "#8D8D8D", width = 7, height = 10, ...props }) => (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M7 1.175L5.66802 0L0 5L5.66802 10L7 8.825L2.67341 5L7 1.175Z" fill={color} />
    </svg>

);
